import moment from "moment";

import { IndividualLight } from "@/Common/Api/Individuals/Dto/IndividualLight";
import { AttachedCommunicationsPopup } from "@/Common/Components/AttachedCommunications/AttachedCommunicationsPopup";
import { DateSelector } from "@/Common/Components/Inputs/DateSelector";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { PortalStatusButton } from "@/Common/Components/Portal/PortalStatusIcon";
import { LuxonDateHelper } from "@/Common/Helpers/LuxonDateHelper";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { NameHelper } from "@/Common/Helpers/NameHelper";
import { PortalHelper } from "@/Common/Helpers/PortalHelper";
import { AttachedCommunication } from "@/Common/Models/AttachedCommunication/AttachedCommunication";
import { AttachedCommunicationType } from "@/Common/Models/AttachedCommunication/AttachedCommunicationType";
import { DocumentClassModel } from "@/Common/Models/DocumentClassModel";
import { Person } from "@/Common/Models/Person/Person";
import { SearchableItemModelT } from "@/Common/Models/SearchableItem";
import { RedirectTo } from "@/Common/Models/UI/Enums";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { LuxonDateTimeParser } from "@/Common/Utilities/DateAndTime/LuxonDateTimeParser";
import { RouterHistory } from "@/Common/Utilities/Router/RouterHistory";
import { MedicalDocumentItem } from "@/Documents/Models/Medical/MedicalDocumentItem";
import { DocumentCreateEditUIModel, IDocumentCreateEditUIModel } from "@/Documents/Models/UI/IDocumentCreateEditUIModel";
import { IDocumentsTabModel } from "@/Documents/Models/UI/IDocumentsTabModel";
import { SendDocumentStrategy } from "@/Documents/Services/Portal/Strategies/SendDocumentStrategy";
import { SendToPortalPopup } from "@/Portal/Components/SendToPortalPopup";
import { AnnotationLogs } from "./AnnotationLogs";
import { CreateNoteInView } from "./CreateNoteInView";
import { DocumentActionHistoryView } from "./DocumentActionHistoryView";
import { RevokeApprovalModal } from "./RevokeApprovalModal";

interface IDocumentViewProps {
    model: IDocumentCreateEditUIModel;
    documentTabModel: IDocumentsTabModel;
    documentClasses: Immutable.List<DocumentClassModel>;
    sources: Immutable.List<SearchableItemModelT<string>>;
    descriptions: Immutable.List<SearchableItemModelT<string>>;
}

class DocumentViewState {
    public isApproveDisabled: boolean;
}

class DocumentView extends React.Component<IDocumentViewProps, DocumentViewState> {
    private readonly helper = new MyleHelper();

    constructor(props: IDocumentViewProps) {
        super(props);

        this.state = new DocumentViewState();
    }

    public render(): JSX.Element {
        let self = this;
        let doc = this.props.model.get("MedicalDocumentInfo");
        const documentAnnotationsLog = this.props.model.get("DocumentAnnotationsLog");
        let docModel = doc.Model;

        let documentDescription = $.trim(docModel.Subject).length > 0 ? docModel.Subject : cacheStore.GetString("AttachmentLabel");
        let headerDisplay = limitTextLength(documentDescription, 50);

        const canApprove = sessionStore.canApproveDocument();

        let documentSubClassLookupId = docModel.SubClassId;
        let documentClassLookup = cacheStore.GetLocalizedValueByLookupId(docModel.ClassId);
        let documentSubclassLookup = cacheStore.GetLocalizedValueByLookupId(documentSubClassLookupId);

        let uploadedBy = "";
        let uploader = this.props.model.get("Clinicians")
            .toArray()
            .filter((c: Person) => c.ContactId === docModel.UploaderContactId);
        if (uploader.length > 0) {
            uploadedBy = uploader[0].NameWithPrefix;
        }

        let documentDate = null;
        if (this.props.model.get("SignOffByContactId") == null) {
            const parsedDate = LuxonDateTimeParser.parse(docModel.ReceiptDate)?.toFormat("yyyy-MM-dd") ?? "";
            documentDate = <strong>{parsedDate}</strong>;
        }
        else {
            documentDate = (
                <div className="clearfix">
                    <div className="pull-left"><DateSelector id="doc_create_date" cssClass="" date={docModel.ReceiptDate} onSelectOp={LocalOperations.Documents.Edit_Set_Document_Date} dateFormat="dddd, MMM dd, yyyy" disabled={this.props.model.get("LockUI")} /></div>
                    <a className="pull-left" style={{ margin: "9px 0 0 15px" }} id="dp1-today" onClick={() => this.onTodayClick()}>{cacheStore.GetString("TodayLabel")}</a>
                </div>
            );
        }

        let documentUploadDate = (docModel.UploadDate == null) ? <strong /> : <strong>{LuxonDateHelper.formatToFullDateTime(docModel.UploadDate)}</strong>;

        let docMapped = docModel.DocumentPathList.map(x => {
            if (x.CreationDate == null)
                x.CreationDate = docModel.UploadDate;
            if (x.UploaderContactId != null) {
                let lastUploader = this.props.model.get("Clinicians")
                    .toArray()
                    .filter((c: Person) => c.ContactId === x.UploaderContactId);
                if (lastUploader.length > 0) {
                    x.UploaderName = lastUploader[0].NameWithPrefix;
                }
            }
            return x;
        });
        docMapped = docMapped.sortByProperty(x => x.CreationDate);
        const documentsRender = docMapped.map((doc, idx) => {
            const readableFileName = this.helper.GetReadableFileName(doc.FileName);
            const docPath = apiSettings.buildAppUrl(`api/medicalDocuments/downloadFile/${doc.Id}/${encodeURIComponent(readableFileName)}`, { auth: true });

            return (
                <div key={idx + "_doc"} style={{ display: "flex" }}>
                    <div className="ellipsis-auto" style={{ width: "250px" }}>
                        <a className="pointer" title={readableFileName} onClick={() => MyleHelper.OpenNewWindow(docPath)}> {readableFileName}</a>
                    </div>
                    {doc.CreationDate != null
                        ? (
                            <div style={{ marginLeft: "5px", width: "165px" }}>
                                <strong>{moment(doc.CreationDate).format("YYYY/MM/DD") + " " + cacheStore.GetString("AtLabel") + " " + moment(doc.CreationDate).format("HH:mm:ss")}</strong>
                            </div>
                        )
                        : (
                            <div>
                                {documentUploadDate}
                            </div>
                        )
                    }
                    {!IsNullOrWhiteSpace(doc.UploaderName)
                        ? (
                            <div style={{ marginLeft: "5px" }}>
                                <strong>{cacheStore.GetString("byLabel") + " " + doc.UploaderName}</strong>
                            </div>
                        )
                        : (
                            <div style={{ marginLeft: "5px" }}>
                                {!IsNullOrWhiteSpace(uploadedBy) &&
                                    <strong> {cacheStore.GetString("byLabel") + " " + uploadedBy}</strong>
                                }
                            </div>
                        )
                    }
                </div>
            );
        });

        let emmiterCode = docModel.SendingFacilityID;
        let reportCode = docModel.SendingFacilityReport;
        let accompanyingSubClass = docModel.AccompanyingSubClass;
        let accompanyingMnemonic = docModel.AccompanyingMnemonic;
        const sourceAuthorName = docModel.SourceAuthorName;
        let observationDate = this.props.model.get("ObservationDate") ? moment(this.props.model.get("ObservationDate")).format("YYYY/MM/D") + " " + cacheStore.GetString("AtLabel") + " " + moment(this.props.model.get("ObservationDate")).format("HH:mm:ss") : "";
        let authoringDate = this.props.model.get("AuthoringDate") ? moment(this.props.model.get("AuthoringDate")).format("YYYY/MM/D") + " " + cacheStore.GetString("AtLabel") + " " + moment(this.props.model.get("AuthoringDate")).format("HH:mm:ss") : "";

        let notesRender = docModel.NoteInfoCollection.sortByPropertyDesc(note => note.NoteDate).map(note => {
            let person = cacheStore.GetEmployeeByContactIdOrEmpty(note.ContactId);
            return (
                <div key={note.NoteId} className="row">
                    <div className="col-lg-2 note-author">
                        <strong>
                            {cacheStore.GetLookupById(person.PrefixLookupId).GetValue()} {person.LastName}, {person.FirstName}
                        </strong>

                        <div>{moment(note.NoteDate).format("YYYY/MM/DD") + " " + cacheStore.GetString("AtLabel") + " " + moment(note.NoteDate).format("HH:mm:ss")}</div>
                    </div>
                    <div className="col-lg-10">
                        <span className="cl-note">{note.NoteContent}</span>
                    </div>
                </div>
            );
        });

        let portalSyncButton: JSX.Element = null;
        if (cacheStore.ClinicSettings_Portal.EnablePortalWebsite) {
            const buttonProps = PortalHelper.getPortalButtonPropsForShareableItem(doc);

            portalSyncButton = (
                <PortalStatusButton
                    icon="share"
                    className="push-right-5 push-left-5"
                    onClick={() => this.PortalStatusClicked(doc)}
                    {...buttonProps}
                />
            );
        }

        if (docModel.Patients != null && docModel.Patients.length > 1)
            portalSyncButton = null;

        if (!PortalHelper.shouldShowPortalShareButton(docModel.Patients))
            portalSyncButton = null;

        let actionButton: JSX.Element = null;
        if (docModel.SignOffDate == null || docModel.SignOffByContactId == null || docModel.SignOffByContactId == "") {
            if (canApprove) {
                actionButton = (
                    <div>
                        <button onClick={() => { LocalEvent.Dispatch(LocalOperations.Documents.ReturnToSearch); }} className="btn btn-default push-right-5 glyf" data-cy="document-view-back" style={{ verticalAlign: "bottom" }}>
                            <span className="glyphicon glyphicon-chevron-left" />
                            <span>{cacheStore.GetString("BackLabel")}</span>
                        </button>

                        <button onClick={() => this.onEditClick()} style={{ marginRight: "5px", verticalAlign: "bottom" }} className="btn btn-primary push-right" data-cy="document-view-edit">{cacheStore.GetString("EDITLabel")}</button>
                        <button className="btn btn-primary" data-cy="document-view-approve" style={{ verticalAlign: "bottom" }} disabled={this.state.isApproveDisabled} onClick={() => this.onApproveClick()}>{cacheStore.GetString("ApproveLabel")}</button>
                        {portalSyncButton}
                    </div>
                );
            }
            else {
                actionButton = (
                    <div>
                        <button onClick={() => { LocalEvent.Dispatch(LocalOperations.Documents.ReturnToSearch); }} className="btn btn-default push-right-5 glyf" data-cy="document-view-back" style={{ verticalAlign: "bottom" }}>
                            <span className="glyphicon glyphicon-chevron-left" />
                            <span>{cacheStore.GetString("BackLabel")}</span>
                        </button>
                        <button onClick={() => this.onEditClick()} style={{ marginRight: "5px", verticalAlign: "bottom" }} className="btn btn-primary push-right" data-cy="document-view-edit">{cacheStore.GetString("EDITLabel")}</button>
                        <button className="btn btn-primary disabled" data-cy="document-view-approve" style={{ verticalAlign: "bottom" }} disabled={true} onClick={() => this.onApproveClick()}>{cacheStore.GetString("ApproveLabel")}</button>
                        {portalSyncButton}
                    </div>
                );
            }
        }
        else {
            actionButton = (
                <div>
                    <button
                        onClick={() => { LocalEvent.Dispatch(LocalOperations.Documents.ReturnToSearch); }}
                        className="btn btn-default push-right-5 glyf"
                        data-cy="document-view-back"
                        style={{ verticalAlign: "bottom" }}
                    >
                        <span className="glyphicon glyphicon-chevron-left" />
                        <span>{cacheStore.GetString("BackLabel")}</span>
                    </button>
                    <button
                        onClick={() => this.onCancelClick()}
                        className="btn btn-default push-right-5"
                        data-cy="document-view-cancel"
                        style={{ verticalAlign: "bottom" }}
                    >
                        {cacheStore.GetString("CancelLabel")}
                    </button>
                    <button
                        className="btn btn-primary push-right-5"
                        data-cy="document-view-save"
                        style={{ verticalAlign: "bottom" }}
                        onClick={() => sessionStore.validatePrescriptionRenewalBeforeDocumentSave(docModel.PrescriptionRenewal, docModel.ClassId, () => this.onSaveApprovedClick())}
                    >
                        {cacheStore.GetString("SaveLabel")}
                    </button>
                    {sessionStore.isAdmin() && (
                        <button
                            className="btn btn-danger"
                            data-cy="document-view-revoke"
                            style={{ "verticalAlign": "bottom" }}
                            onClick={() =>
                                sessionStore.dispatch(LocalOperations.Documents.View_UnapproveClick)
                            }
                        >
                            {cacheStore.GetString("RevokeApprovalLabel")}
                        </button>
                    )}
                    {portalSyncButton}
                </div>
            );
        }

        var hrmStatus: string;
        if (this.props.model.get("SelectedHRMStatus")) {
            let selectedHRM = this.props.model.get("HRMStatusList")
                .filter(st => st.Key === this.props.model.get("SelectedHRMStatus"));

            if (selectedHRM && selectedHRM.size > 0)
                hrmStatus = selectedHRM.get(0).Value;
        }

        let lastModifiedRender = null;
        if (this.props.model.get("LastModifiedByDate")) {
            lastModifiedRender = DocumentCreateEditUIModel.generateDocumentViewFooter(
                self.props.model.get("LastModifiedBy"),
                cacheStore.GetString("LastModifiedByLabel"),
                this.props.model.get("LastModifiedByDate")
            );
        }

        let signOffRender = null;
        if (this.props.model.get("SignOffDate") != null && this.props.model.get("SignOffByContactId") != null && this.props.model.get("SignOffByContactId") != "") {
            signOffRender = DocumentCreateEditUIModel.generateDocumentViewFooter(
                self.props.model.get("SignOffByContactId"),
                cacheStore.GetString("ApprovedByLabel"),
                this.props.model.get("SignOffDate")
            );
        }

        let revokedByRender: string;
        if (this.props.model.get("RevokedOn") && this.props.model.get("RevokedByContactId")) {
            revokedByRender = DocumentCreateEditUIModel.generateDocumentViewFooter(
                self.props.model.get("RevokedByContactId"),
                cacheStore.GetString("RevokedByLabel"),
                this.props.model.get("RevokedOn")
            );
        }

        let sourceRender = null;
        if (this.props.model.get("SignOffByContactId") == null) {
            sourceRender = <strong data-cy="document-view-source">{docModel.Source}</strong>;
        }
        else {
            sourceRender = <TextboxControl dataCy="document-view-source" disabled={this.props.model.get("LockUI")} autoCompleteItems={this.props.sources} value={docModel.Source} operation={LocalOperations.Documents.Edit_OnSourcesChange} onAutoCompleteSelectCallBackOperation={LocalOperations.Documents.Edit_OnSourcesChange} />;
        }

        let descriptionRender = null;
        if (this.props.model.get("SignOffByContactId") == null) {
            descriptionRender = <strong title={documentDescription}>{headerDisplay}</strong>;
        }
        else {
            descriptionRender = <TextboxControl disabled={this.props.model.get("LockUI")} autoCompleteItems={this.props.descriptions} value={docModel.Subject} operation={LocalOperations.Documents.Edit_OnDescriptionChange} onAutoCompleteSelectCallBackOperation={LocalOperations.Documents.Edit_OnDescriptionChange} />;
        }

        let noteControl = null;
        let addNoteBtnLink = <div style={{ marginBottom: "30px" }}><a onClick={e => this.showAddNoteControl(e)}>{cacheStore.GetString("AddNoteLabel")}</a></div>;
        if (this.props.model.get("ShowNoteCreateForm") === true) {
            addNoteBtnLink = null;
            noteControl = (
                <div className="row">
                    <div className="columns col-lg-5 col-md-8 ">
                        <CreateNoteInView addNoteOperation={LocalOperations.Documents.View_AddNewNote} hideControlOperation={LocalOperations.Documents.View_HideNewNotesControl} />
                    </div>
                </div>
            );
        }

        let siteRender = null;
        let sites = cacheStore.SiteCache;
        if (sites.length > 1) {
            siteRender = (
                <div className="row">
                    <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                        <label className="form-label">{cacheStore.GetString("SitesLabel")}</label>
                    </div>
                    <div className="col-lg-10 col-md-8 ">
                        <strong data-cy="document-view-site">{cacheStore.GetSiteNameById(docModel.SiteId)}</strong>
                    </div>
                </div>
            );
        }

        return (
            <div className="workspace">
                {this.props.model.get("UnapprovePopupOpen") && (
                    <RevokeApprovalModal
                        onClose={() => sessionStore.dispatch(LocalOperations.Documents.View_UnapproveClick)}
                        document={doc}
                    />
                )}
                {this.props.documentTabModel.get("AttachedCommunicationsPopupOpen") && (
                    <AttachedCommunicationsPopup
                        controlId="attached_communications_documentview"
                        dataCy="documentView-attachedCommunicationsPopup"
                        attachedCommunications={docModel.IndividualTaskLinkedItems}
                        leftPosition={this.props.documentTabModel.get("AttachedCommunicationsPopupX")}
                        topPosition={this.props.documentTabModel.get("AttachedCommunicationsPopupY")}
                        context={AttachedCommunicationType.Task}
                        handleRedirect={ac => this.taskRedirectClick(ac)}
                        handleClose={() => this.taskRedirectClose()}
                    />
                )}

                {this.props.documentTabModel.get("IsSendToPatientPortalPopupOpen") && (
                    <SendToPortalPopup
                        model={this.props.documentTabModel.get("PortalLinkedItemModel")}
                        strategy={new SendDocumentStrategy()}
                    />
                )}

                <div className="myle-page-header bottom-border">

                    <div className="row">
                        <div className="col-lg-12 col-md-12 ">
                            <p className="header-font-color uppercase">{cacheStore.GetString("DocumentsLabel")}</p>
                            {docModel.IsUrgent === false && <h3 title={documentDescription} className="thin-font">{headerDisplay}</h3>}
                            {docModel.IsUrgent === true && <h3 className="thin-font bold red-text">URGENT <span title={documentDescription} style={{ color: "#274771", fontSize: "16px" }}>{headerDisplay}</span></h3>}
                        </div>
                    </div>
                </div>
                <div id="posref" className="ws-scrollable" style={{ minWidth: "860px" }}>
                    <div className="myle-doc-tb main-content myle-form documents">
                        <div className="row">
                            <div className="col-lg-2 col-md-4 text-right-lg text-right-md">
                                <label className="form-label">{cacheStore.GetString("PatientsLabel")}</label>
                            </div>
                            <div className="col-lg-10 col-md-8">
                                <span className="pull-right" style={{ marginRight: "10px" }}>
                                    <a onClick={e => this.ShowTaskWindow(doc, e)} data-cy="document-view-newTask">{cacheStore.GetString("NewTaskLabel")}</a>
                                    {docModel.IndividualTaskLinkedItems.any() && (
                                        <span
                                            style={{ marginLeft: "5px", cursor: "pointer" }}
                                            onClick={e => this.onTaskTrailClick(e)}
                                            className={docModel.AreAllTasksCompleted ? "circle-green" : "circle-orange"}
                                        >
                                            {docModel.IndividualTaskLinkedItems.length}
                                        </span>
                                    )}
                                </span>
                                {docModel.Patients.map((patient: IndividualLight, idx) => (
                                    <div key={"patient_" + idx} data-cy="documentView-patient">
                                        <a className="bold pointer" onClick={() => self.openPatientFile(patient.Id)}>
                                            {NameHelper.formatFullNameForHasName(patient)}
                                        </a>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                <label className="form-label">{cacheStore.GetString("ResponsibleProvidersLabel")}</label>
                            </div>
                            <div className="col-lg-10 col-md-8 ">
                                {docModel.ResponsibleProviders.map((provider: IndividualLight, idx) => {
                                    let prefix = "";
                                    let prefixlookup = cacheStore.GetLookupById(provider.Prefix);
                                    if (prefixlookup != null)
                                        prefix = cacheStore.GetLocalizedValueByLookupId(prefixlookup.LookupID) + " ";

                                    return (<div key={"provider" + idx}><strong data-cy="document-view-provider">{prefix}{provider.LastName}, {provider.FirstName}</strong></div>);
                                })}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                <label className="form-label">{cacheStore.GetString("ClassLabel")}</label>
                            </div>
                            <div className="col-lg-6 col-md-8 ">
                                {this.props.model.get("SignOffByContactId") == null && <strong data-cy="document-view-class">{documentClassLookup + ": " + documentSubclassLookup}</strong>}

                                {this.props.model.get("SignOffByContactId") != null && (
                                    <select className="form-control myle-control" onChange={e => this.OnClassSubClassSelectionChange(e)}>
                                        {this.props.documentClasses.toArray().map(g => (
                                            <optgroup key={g.LookupId} label={cacheStore.GetLocalizedValueByLookupId(g.LookupId)}>
                                                {g.SubClasses.toArray().map(s => {
                                                    let isSelected = (documentSubClassLookupId === s.LookupId);
                                                    let formattedOutput = cacheStore.GetLocalizedValueByLookupId(g.LookupId) + " - " + cacheStore.GetLocalizedValueByLookupId(s.LookupId);

                                                    return (
                                                        <option
                                                            key={s.LookupId}
                                                            selected={isSelected}
                                                            value={g.LookupId + "&" + s.LookupId}
                                                        >
                                                            {formattedOutput}
                                                        </option>
                                                    );
                                                })}
                                            </optgroup>
                                        ))}
                                    </select>
                                )}
                            </div>
                        </div>
                        {siteRender}

                        <div className="row">
                            <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                <label className="form-label">{cacheStore.GetString("SourceLabel")}</label>
                            </div>
                            <div className="col-lg-6 col-md-8 ">
                                {sourceRender}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                <label className="form-label">{cacheStore.GetString("UploadedByLabel")}</label>
                            </div>
                            <div className="col-lg-10 col-md-8 ">
                                <strong>{uploadedBy}</strong>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                <label className="form-label">{cacheStore.GetString("DescriptionDLabel")}</label>
                            </div>
                            <div className="col-lg-6 col-md-8 ">
                                {descriptionRender}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                <label className="form-label">{cacheStore.GetString("DocumentDateLabel")}</label>
                            </div>
                            <div className="col-lg-10 col-md-8 col-sm-4">
                                <strong>{documentDate}</strong>
                            </div>
                        </div>
                        <div className="row paddingbottom15">
                            <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                <label className="form-label">{cacheStore.GetString("DocumentGridFilesLabel")}</label>
                            </div>
                            <div className="col-lg-10 col-md-8 ">
                                {documentsRender}
                            </div>
                        </div>

                        <div className="row additional_details">
                            <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                <label className="form-label">{cacheStore.GetString("SendingFacilityIDDLabel")}</label>
                            </div>
                            <div className="col-lg-10 col-md-8 ">
                                <strong data-cy="document-view-sendingFacilityID">{emmiterCode}</strong>
                            </div>
                        </div>

                        <div className="row additional_details ">
                            <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                <label className="form-label">{cacheStore.GetString("SendingFacilitySenderFacilityReportDLabel")}</label>
                            </div>
                            <div className="col-lg-10 col-md-8 ">
                                <strong data-cy="document-view-sendingFacilityReport">{reportCode}</strong>
                            </div>
                        </div>

                        <div className="row additional_details ">
                            <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                <label className="form-label">{cacheStore.GetString("AccompanyingSubClassLabel")}</label>
                            </div>
                            <div className="col-lg-10 col-md-8 ">
                                <strong data-cy="document-view-accompanyingSubClass">{accompanyingSubClass}</strong>
                            </div>
                        </div>

                        <div className="row additional_details ">
                            <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                <label className="form-label">{cacheStore.GetString("AccompanyingMnemonicLabel")}</label>
                            </div>
                            <div className="col-lg-10 col-md-8 ">
                                <strong data-cy="document-view-accompanyingMnemonic">{accompanyingMnemonic}</strong>
                            </div>
                        </div>

                        {cacheStore.ClinicSettings.EnableDocumentSourceAuthorField && (
                            <div className="row additional_details ">
                                <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                    <label className="form-label">{cacheStore.GetString("SourceAuthorNameLabel")}</label>
                                </div>
                                <div className="col-lg-10 col-md-8 ">
                                    <strong>{sourceAuthorName}</strong>
                                </div>
                            </div>
                        )}

                        <div className="row additional_details ">
                            <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                <label className="form-label">{cacheStore.GetString("AuthoringDateTimeLabel")}</label>
                            </div>
                            <div className="col-lg-10 col-md-8 ">
                                <strong data-cy="document-view-authoringDateTime">{authoringDate}</strong>
                            </div>
                        </div>

                        <div className="row additional_details ">
                            <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                <label className="form-label">{cacheStore.GetString("ObservationDateTimeLabel")}</label>
                            </div>
                            <div className="col-lg-10 col-md-8 ">
                                <strong data-cy="document-view-observationDateTime">{observationDate}</strong>
                            </div>
                        </div>

                        <div className="row additional_details ">
                            <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                <label className="form-label">{cacheStore.GetString("HRMStatusDLabel")}</label>
                            </div>
                            <div className="col-lg-10 col-md-8 ">
                                <strong data-cy="document-view-hRMStatus">{hrmStatus}</strong>
                            </div>
                        </div>
                        {cacheStore.ClinicSettings.EnableDocumentInAppView && (
                            <div className="row additional_details ">
                                <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                    <label className="form-label">{cacheStore.GetString("DocumentView_AnnotationLogsLabel")}</label>
                                </div>
                                <div className="col-lg-10 col-md-8">
                                    <AnnotationLogs logs={documentAnnotationsLog} />
                                </div>
                            </div>
                        )}
                        {cacheStore.ClinicSettings.EnableDocumentSignoffHistory && (
                            <div className="row additional_details ">
                                <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                    <label className="form-label">{cacheStore.GetString("SignOffHistoryLabel")}</label>
                                </div>
                                <div className="col-lg-10 col-md-8">
                                    <DocumentActionHistoryView history={this.props.model.get("DocumentActionHistoryLog")} />
                                </div>
                            </div>
                        )}
                        <div className="row ">
                            <div className="col-lg-2 col-md-4  text-right-lg text-right-md">
                                <label className="form-label">{cacheStore.GetString("NotesLabel")}</label>
                            </div>
                            <div className="col-lg-10 col-md-8 ">
                                {addNoteBtnLink}

                                {noteControl}

                                {notesRender}
                            </div>
                        </div>
                    </div>

                </div>

                <div className="ws-footer">
                    <div className="row native document-approve-view">
                        <div className="col-md-6">
                            <p className="footer-col-smtext">{signOffRender}</p>
                            <p className="footer-col-smtext">{revokedByRender}</p>
                            <p className="footer-col-smtext">{lastModifiedRender}</p>
                        </div>
                        <div className="col-md-6  text-right-lg text-right-md">
                            {actionButton}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private mutateState(mutation: (s: DocumentViewState) => void, then: () => void = null): void {
        let s = new DocumentViewState();
        mutation(s);
        this.setState(s, then);
    }

    public onCancelClick(): void {
        var operation = new LocalEvent(LocalOperations.Documents.Show_DocumentSearch);
        LocalEventDispatcher.dispatch(operation);
    }

    public onEditClick(): void {
        var operation = new LocalEvent(LocalOperations.Documents.View_ShowEdit);
        LocalEventDispatcher.dispatch(operation);
    }

    public onApproveClick(): void {
        this.mutateState(s => s.isApproveDisabled = true);

        var operation = new LocalEvent(LocalOperations.Documents.Edit_OnApproveClick);
        LocalEventDispatcher.dispatch(operation);
    }

    public OnClassSubClassSelectionChange(e: React.ChangeEvent<HTMLSelectElement>): void {
        var selected: string = e.target.value;
        var classes = selected.split("&");
        var operation = new LocalEvent(LocalOperations.Documents.Edit_SubClassChange);
        operation.AddItem("value_class", classes[0]);
        operation.AddItem("value_subclass", classes[1]);

        LocalEventDispatcher.dispatch(operation);
    }

    public onTodayClick(): void {
        var operation = new LocalEvent(LocalOperations.Documents.Edit_OnTodayClick);
        LocalEventDispatcher.dispatch(operation);
    }

    public onSaveApprovedClick(): void {
        sessionStore.dispatch(LocalOperations.Documents.Edit_SaveApprovedDocument);
    }

    public componentDidMount(): void {
        $(window).trigger("resize");
    }

    private showAddNoteControl(e: React.MouseEvent): void {
        e.preventDefault();
        var operation = new LocalEvent(LocalOperations.Documents.View_ShowNewNotesControl);
        LocalEventDispatcher.dispatch(operation);
    }

    private PortalStatusClicked(medicalDocumentItem: MedicalDocumentItem): void {
        var operation = new LocalEvent(LocalOperations.Documents.PortalStatusClicked);
        operation.AddItem("doc", medicalDocumentItem);
        LocalEventDispatcher.dispatch(operation);
    }

    private openPatientFile(patientId: string): void {
        var openPatientOperation = new LocalEvent(LocalOperations.Misc.RedirectToTab);

        openPatientOperation.AddItem("value", patientId);
        openPatientOperation.AddItem("target", RedirectTo.Patient);
        openPatientOperation.AddItem("currentLocation", RouterHistory.location);

        LocalEventDispatcher.dispatch(openPatientOperation);
    }

    private ShowTaskWindow(document: MedicalDocumentItem, e: React.MouseEvent): void {
        e.preventDefault();
        e.stopPropagation();

        sessionStore.dispatch(
            LocalOperations.SendTaskOrMessageModel.Show_TaskOrMessage_Popup,
            {
                isTask: true,
                documentInfo: document,
                fromCreateView: true
            }
        );
    }

    private onTaskTrailClick(e: React.MouseEvent): void {
        sessionStore.dispatch(
            LocalOperations.Documents.View_TrailClick,
            {
                eventY: e.clientY,
                eventX: e.clientX
            }
        );
    }

    private taskRedirectClick(attachedCommunication: AttachedCommunication): void {
        sessionStore.dispatch(
            LocalOperations.Documents.View_AttachedCommunicationClick,
            {
                attachedCommunication: attachedCommunication
            }
        );
    }

    private taskRedirectClose(): void {
        sessionStore.dispatch(LocalOperations.Documents.View_AttachedCommunicationClose);
    }
}

export { DocumentView, DocumentViewState, IDocumentViewProps };
